import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { HOME } from '../../common/constants/routes'

const MasterRoutes = () => {
    const isMasterPassword = useSelector((state) => state.auth?.user?.isMasterPassword)

    return isMasterPassword ? <Outlet /> : <Navigate to={HOME} replace />
}

export default MasterRoutes
